import { MeshBasicMaterial, FrontSide } from "three";
/**
 * Global variables and constants
 */
export class Globals {
    /**
     * Canvas container where will be created the canvas used to render scenes
     */
    static canvasContainer;
    /**
     * Canvas that renders scene
     */
    static canvas;
    /**
     * Shared material used for all mesh used only to raycast and never visible // remove this because cannot be shared in different scenes or context
     */
    static materialForObjectToRaycast = new MeshBasicMaterial({ visible: false, side: FrontSide });
}
//# sourceMappingURL=Globals.js.map